jQuery(document).ready(function () {
  // 
  jQuery('.header__heading-logo-wrapper img').attr("alt","Zojirushi Treasuring Everyday life online store");
  // 
  
  jQuery('.powered_by_link a').attr('tabindex', '-1');
  jQuery('.powered_by_link a').css('display', 'none');

  // 
  setTimeout(()=>{	
    jQuery('.cart-notification-product__image img').attr('alt', '');
    jQuery('.media.media--transparent.media--hover-effect img').attr('alt', '');
  }, 5000);	

  // 
  

  // 
  jQuery('.cart-item__image-container img').attr('alt', '');

  // 
   jQuery("ul.icon-with-text").each(function() {
      var $ul = jQuery(this);
      var $newDiv = jQuery("<div>").addClass($ul.attr("class")).addClass($ul.attr("class").replace("list-unstyled", ""));
      $ul.children().each(function() {
        var $li = jQuery(this);
        var $newDivItem = jQuery("<div>").addClass($li.attr("class"));
        $newDivItem.append($li.contents());
        $newDiv.append($newDivItem);
      });
      $ul.replaceWith($newDiv);
    });


  // 36
  jQuery('.quick-add-hidden .slider-button.slider-button--next').attr('aria-label', 'Next');
  jQuery('.quick-add-hidden .slider-button.slider-button--prev').attr('aria-label', 'Previous');

// 25
  jQuery('.slider-mobile-gutter:eq(4) li').addClass('multi-slider');
  var i = 1;
		    jQuery(".multi-slider").each(function () {
		      var name = jQuery(this).find("h2").attr("id", "a"+i);

		      jQuery(this).find(".link.animate-arrow").attr("id", "s"+i);
		      jQuery(this).find(".link.animate-arrow").attr('aria-labelledby', 's'+ i +' '+'a'+ i);
		      i+=1;
		    });


  // 
  jQuery('.image-with-text__text-item.grid__item:eq(0) h2').attr('id', 'sr-1');
  jQuery('.image-with-text__text-item.grid__item a').attr('id', 'sr-2');
  jQuery('.image-with-text__text-item.grid__item a').attr('aria-labelledby', 'sr-2 sr-1');

  jQuery('.rich-text__heading:eq(0)').attr('id', 'sr-2');
  jQuery('.center.small-hide:eq(0) a').attr('id', 'sr-3');
  jQuery('.center.small-hide:eq(0) a').attr('aria-labelledby', 'sr-3 sr-2');

  jQuery('.rich-text__heading:eq(1)').attr('id', 'sr-3');
  jQuery('.center.small-hide:eq(1) a').attr('id', 'sr-4');
  jQuery('.center.small-hide:eq(1) a').attr('aria-labelledby', 'sr-4 sr-3');

  jQuery('.rich-text__heading:eq(2)').attr('id', 'sr-4');
  jQuery('.center.small-hide:eq(2) a').attr('id', 'sr-5');
  jQuery('.center.small-hide:eq(2) a').attr('aria-labelledby', 'sr-5 sr-4');

  jQuery('.title.inline-richtext.h2').attr('id', 'sr-5');
  jQuery('.center.small-hide:eq(3) a').attr('id', 'sr-6');
  jQuery('.center.small-hide:eq(3) a').attr('aria-labelledby', 'sr-6 sr-5');

  
// 21
  setTimeout(()=>{	
      jQuery('.grid__item').each(function() {
        var textContent = jQuery(this).find('.card__content h3.h5 a').text();
        jQuery(this).find('button.swym-add-to-wishlist-view-product').attr('aria-label', 'Add to Wishlist: ' + textContent);
    });
  }, 5000);	

  // 
  jQuery('.collage-card .deferred-media__poster').attr('aria-label', 'Customer Favorite with All the Popular Features');
  
   // jQuery('div.cart-item__price-wrapper,div.totals').attr('aria-live', 'polite');
    //  jQuery('.banner__buttons a.button').each(function() {
    //      var textContent = jQuery(this).text();         
    //      jQuery(this).attr("aria-label",""+ textContent +" of gift certificate");
    // });
});

// 
jQuery('.shopify-section.announcement-bar-section').children('div:eq(0)').addClass('top-header');

// 
var textContent = jQuery('.product__title h1').text();
    jQuery('.product__media.media.media--transparent img:eq(0)').attr('aria-label', '' + textContent);

// 
jQuery('.slideshow__media:eq(0) img').attr('alt','Introducing GOCAFE™ Insulated Mug');
jQuery('.slideshow__media:eq(4) img').attr('alt','IH Rice Cooker with the Popular Flat-Top Design');
jQuery('.slideshow__media:eq(2) img').attr('alt','Zojirushi Collection. Treasure your moments.');
jQuery('.slideshow__media:eq(3) img').attr('alt','Zojirushi Sale');

// 
jQuery('.banner__buttons:eq(0) a').attr('aria-label', 'Learn More');
jQuery('.banner__buttons:eq(4) a').attr('aria-label', 'Shop Our New IH Rice Cooker');
jQuery('.banner__buttons:eq(2) a').attr('aria-label', 'See all products');
jQuery('.banner__buttons:eq(3) a').attr('aria-label', 'Shop our sale');
 
